import Navbar from "../components/Navbar";
import Footer from '../components/Footer';
import BackToTop from '../components/BackToTop';
import Funds from '../components/Funds';
import PageHeader from "../components/PageHeader";
import አድራሻ from "../components/አድራሻ";

export default function About() {
    return (
        <>
            <Navbar />
            {/* <PageHeader title="ስለ ማህበሩ" path="/ስለ_ማህበሩ" name="ስለ ማህበሩ" /> */}
            <አድራሻ />
            <Funds />
            <Footer />
            <BackToTop />
        </>
    );
}